import classNames from 'classnames'
import type { VFC } from 'react'

import { type AttributePickers } from 'views/containers/browser/ProductVariantsAttributesContainer/AttributePicker'

const AttributePickerColor: VFC<AttributePickers> = ({
  pickerValue,
  id,
  styles,
}) => {
  const [colorName, colorHexNumber] = pickerValue.split('#')
  styles +=
    ' colorPicker u-margin-x-small--top u-margin-small--right u-padding-xx-small--left l-flex a-full-width'

  const colorPickerHexNumberStyles = classNames('colorPickerColor', {
    'whiteColorPickerColor':
      colorHexNumber?.toLowerCase() === 'fff' ||
      colorHexNumber?.toLowerCase() === 'ffffff',
  })
  return (
    <button
      className={styles}
      name="variantAttribute"
      id={id}
      title={colorName}
      value={pickerValue}
      data-qa-id={`attributePicker-${id}`}
    >
      <span
        style={{ backgroundColor: `#${colorHexNumber}` }}
        className={colorPickerHexNumberStyles}
      ></span>
      <span id={id} className="o-buttonValueDisplay-margin u-text-truncate">
        {colorName}
      </span>
    </button>
  )
}

export default AttributePickerColor
